import { Box, Button } from '@chakra-ui/react';
import { Icon } from '@common/components/Icon';
import currency from '@common/utility/currency';
import { useCheckoutSFRViewModel } from '../../../models/CheckoutSFRViewModel';
import React = require('react');

type SubmitButtonProps = {
  isDisabled: boolean;
};

export const SubmitButton: React.FC<SubmitButtonProps> = ({ isDisabled }) => {
  const viewModel = useCheckoutSFRViewModel();
  return (
    <Button
      isDisabled={isDisabled}
      type="submit"
      rightIcon={<Icon icon="chevron-right" />}
      leftIcon={<Box w={'16px'} />}
      height={'60px'}
      justifyContent="space-between"
      width={['full']}>
      Confirm {currency.format(viewModel.amount)} Investment
    </Button>
  );
};
